import {
  Box,
  Button,
  CustomSelect,
  Icon,
  MUIDataTableColumn,
  MUIDataTableMeta,
  SuccessStateInfo,
  TableActionTypes,
  TableState,
  Typography,
} from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import React from 'react';
import { customFilterChipRender } from '../../../hooks/table';
import {
  stringToLongDateAndShortTimeWithSecond,
  stringToSemanticDisplay,
} from '../../../utils/DateUtils';
import { SelectChangeEvent } from '@mui/material';

export const candidateColumn = (classes: any): MUIDataTableColumn => ({
  name: 'candidateId',
  label: 'NRIC/FIN/ Passport No',
  options: {
    sort: false,
    filter: false,
    customBodyRender: (value: any, tableMeta: MUIDataTableMeta, updateValue: (value: any) => void) => (
      <Box>
        <Typography variant="body1">{value}</Typography>
        <Typography variant="subtitle2" className={classes.citizenText}>
          {tableMeta.rowData[13]}
        </Typography>
      </Box>
    ),
  },
});

export const statutoryNameColumn = (
  remoteTotalRowsSelected: number,
  classes: any
): MUIDataTableColumn => ({
  name: 'statutoryName',
  label: 'Statutory name',
  options: {
    customBodyRender: (value: any, tableMeta: MUIDataTableMeta) => (
      <Box>
        <Typography variant="body2">{value}</Typography>
        <Typography variant="subtitle2" className={classes.citizenText}>
          {tableMeta.rowData[2]}
        </Typography>
      </Box>
    ),
    sort: remoteTotalRowsSelected === 0,
    filter: false,
  },
});

export const citizenshipColumn = (
  remoteTotalRowsSelected: number,
  classes: any,
  tableDispatch: React.Dispatch<TableActionTypes>,
  filterMappingCitizenship: any,
  state: TableState,
  filterCodeCitizenship: any
): MUIDataTableColumn => ({
  name: 'citizenship',
  options: {
    display: false,
    sort: remoteTotalRowsSelected === 0,

    filter: true,
    filterType: 'custom',

    customFilterListOptions: {
      render: (v:any) => [filterMappingCitizenship[v[0]].children],
      update: (filterList: string[][],
filterPos: number,
index: number) => {
        // update table filter state
        tableDispatch({
          type: 'UPDATE_FILTERS',
          payload: { ...state.filters, citizenship: [] },
        });

        // update table inner filter
        return customFilterChipRender(filterList, filterPos, index);
      },
    },
    filterOptions: {
      fullWidth: true,
      display: (filterList: string[][], onChange: (val: string | string[], index: number, column: MUIDataTableColumn) => void, index: number, column: MUIDataTableColumn) => (
        <CustomSelect
          className={classes.select}
          // eslint-disable-next-line react/destructuring-assignment
          defaultValue={filterList[index][0]}
          displayEmpty
          menuItems={filterCodeCitizenship}
          onChange={(event) => {
            // eslint-disable-next-line no-param-reassign
            filterList[index][0] = event.target.value as string;
            onChange(filterList[index], index, column);
          }}
          label="Citizenship"
          labelId="inputSelectLabel-citizenship"
          id="inputSelect-citizenship"
        />
      ),
    },
  },
});

export const candidateTypeColumn = (
  remoteTotalRowsSelected: number,
  classes: any,
  tableDispatch: React.Dispatch<TableActionTypes>,
  filterMappingCandidateType: any,
  state: TableState,
  filterCodeCandidateType: any
): MUIDataTableColumn => ({
  name: 'candidateType',
  label: 'Candidate Type',
  options: {
    sort: remoteTotalRowsSelected === 0,
    filter: true,
    filterType: 'custom',
    // chip logic
    customFilterListOptions: {
      render: (v:any) => [filterMappingCandidateType[v[0]].children],
      update: (filterList: string[][],
filterPos: number,
index: number) => {
        // update table filter state
        tableDispatch({
          type: 'UPDATE_FILTERS',
          payload: { ...state.filters, candidateType: [] },
        });

        // update table inner filter
        return customFilterChipRender(filterList, filterPos, index);
      },
    },
    filterOptions: {
      fullWidth: true,
      display: (filterList: string[][], onChange: (val: string | string[], index: number, column: MUIDataTableColumn) => void, index: number, column: MUIDataTableColumn) => (
        <CustomSelect
          className={classes.select}
          // eslint-disable-next-line react/destructuring-assignment
          defaultValue={filterList[index][0]}
          displayEmpty
          menuItems={filterCodeCandidateType}
          onChange={(event) => {
            // eslint-disable-next-line no-param-reassign
            filterList[index][0] = event.target.value as string;
            onChange(filterList[index], index, column);
          }}
          label="Candidate Type"
          labelId="inputSelectLabel-candidateType"
          id="inputSelect-candidateType"
        />
      ),
    },
  },
});

export const examLevelColumn = (
  remoteTotalRowsSelected: number,
  classes: any,
  tableDispatch: React.Dispatch<TableActionTypes>,
  filterMappingExamLevel: any,
  state: TableState,
  filterCodeExamLevel: any
): MUIDataTableColumn => ({
  name: 'examLevel',
  label: 'Candidate Results Exam Level',
  options: {
    customBodyRenderLite: (dataIndex:number) => {
      const value = filterMappingExamLevel[state.data[dataIndex].examLevel];
      return !value ? '–' : value.children;
    },
    sort: remoteTotalRowsSelected === 0,
    filter: true,
    filterType: 'custom',
    customFilterListOptions: {
      render: (v:any) => [filterMappingExamLevel[v[0]].children],
      update: (filterList: string[][],
filterPos: number,
index: number) => {
        // update table filter state
        tableDispatch({
          type: 'UPDATE_FILTERS',
          payload: { ...state.filters, examLevel: [] },
        });

        // update table inner filter
        return customFilterChipRender(filterList, filterPos, index);
      },
    },
    filterOptions: {
      fullWidth: true,
      display: (filterList: string[][], onChange: (val: string | string[], index: number, column: MUIDataTableColumn) => void, index: number, column: MUIDataTableColumn) => (
        <CustomSelect
          className={classes.select}
          // eslint-disable-next-line react/destructuring-assignment
          defaultValue={filterList[index][0]}
          displayEmpty
          menuItems={filterCodeExamLevel}
          onChange={(event) => {
            // eslint-disable-next-line no-param-reassign
            filterList[index][0] = event.target.value as string;
            onChange(filterList[index], index, column);
          }}
          label="Candidate Results Exam Level"
          labelId="inputSelectLabel-candidateResultsExamLevel"
          id="inputSelect-candidateResultsExamLevel"
        />
      ),
    },
  },
});

export const emailColumn = (remoteTotalRowsSelected: number): MUIDataTableColumn => ({
  name: 'emailAddress',
  label: 'Email',
  options: {
    sort: remoteTotalRowsSelected === 0,
    filter: false,
  },
});

// @ts-ignore
export const schoolColumn = (
  remoteTotalRowsSelected: number,
  classes: any,
  tableDispatch: React.Dispatch<TableActionTypes>,
  filterMappingSchool: any,
  state: TableState,
  filterCodeSchool: any
): MUIDataTableColumn => ({
  name: 'school',
  label: 'School',
  options: {
    sort: remoteTotalRowsSelected === 0,
    filter: true,
    filterType: 'custom',
    customBodyRenderLite: (dataIndex:number) => {
      const school = filterMappingSchool[state.data[dataIndex].school];
      return school ? school.children : '';
    },
    customFilterListOptions: {
      render: (v:any) => {
        if (v.length > 1) {
          return [`${filterMappingSchool[v[0]].children}, ..`];
        }
        if (v.length === 1) {
          return [filterMappingSchool[v[0]].children];
        }
        return [];
      },
      update: (filterList: string[][],
filterPos: number,
index: number) => {
        // update table filter state
        tableDispatch({
          type: 'UPDATE_FILTERS',
          payload: { ...state.filters, school: [] },
        });

        // update table inner filter
        return customFilterChipRender(filterList, filterPos, index);
      },
    },
    filterOptions: {
      fullWidth: true,
      display: (filterList: string[][], onChange: (val: string | string[], index: number, column: MUIDataTableColumn) => void, index: number, column: MUIDataTableColumn) => (
        <CustomSelect
          className={classes.select}
          displayEmpty
          variant="filled"
          multiple
          label="Select School"
          labelId="inputSelectLabel-schoolOptions"
          id="inputSelect-schoolOptions"
         onChange={(e: SelectChangeEvent<unknown>) => {
            // eslint-disable-next-line no-param-reassign
            filterList[index] = e.target.value as string[];
            onChange(filterList[index], index, column);
            window.dispatchEvent(new CustomEvent('resize'));
          }}
          menuItems={filterCodeSchool}
          // eslint-disable-next-line no-param-reassign,react/destructuring-assignment
          value={filterList[index]}
          renderValue={(selected: unknown | string[]) =>
            Array.isArray(selected) && selected.length > 0
              ? // @ts-ignore
                filterCodeSchool
                  .filter((school: any) => selected.includes(school.value))
                  .map((s: any) => s.children)
                  .join(', ')
              : 'Select School'
          }
        />
      ),
    },
  },
});

export const authenticationColumn = (
  remoteTotalRowsSelected: number,
  classes: any,
  tableDispatch: React.Dispatch<TableActionTypes>,
  filterMappingAuthentication: any,
  state: TableState,
  filterCodeAuthentication: any
): MUIDataTableColumn => ({
  name: 'authentication',
  label: 'Authentication',
  options: {
    customBodyRenderLite: (dataIndex:number) => {
      const authentication = filterMappingAuthentication[state.data[dataIndex].authentication];
      return authentication ? authentication.children : '';
    },
    sort: remoteTotalRowsSelected === 0,
    filter: true,
    filterType: 'custom',
    customFilterListOptions: {
      render: (v:any) => [filterMappingAuthentication[v[0]].children],
      update: (filterList: string[][],
filterPos: number,
index: number) => {
        // update table filter state
        tableDispatch({
          type: 'UPDATE_FILTERS',
          payload: { ...state.filters, authentication: [] },
        });

        // update table inner filter
        return customFilterChipRender(filterList, filterPos, index);
      },
    },
    filterOptions: {
      fullWidth: true,
      display: (filterList: string[][], onChange: (val: string | string[], index: number, column: MUIDataTableColumn) => void, index: number, column: MUIDataTableColumn) => (
        <CustomSelect
          className={classes.select}
          // eslint-disable-next-line react/destructuring-assignment
          defaultValue={filterList[index][0]}
          displayEmpty
          menuItems={filterCodeAuthentication}
          onChange={(event) => {
            // eslint-disable-next-line no-param-reassign
            filterList[index][0] = event.target.value as string;
            onChange(filterList[index], index, column);
          }}
          label="Authentication"
          labelId="inputSelectLabel-authentication"
          id="inputSelect-authentication"
        />
      ),
    },
  },
});

export const accountCreationColumn = (
  generateLoading: boolean,
  classes: any,
  generateMutate: (tableMeta: MUIDataTableMeta) => void,
  remoteTotalRowsSelected: number,
  hasCreateAccess: boolean
): MUIDataTableColumn => ({
  name: 'accountDateTime',
  label: 'Account Creation',
  options: {
    display: hasCreateAccess,
    customBodyRender: (value: any, tableMeta: MUIDataTableMeta, updateValue: (value: any) => void)  => {
      if (value) {
        return (
          <SuccessStateInfo>
            <Typography variant="body2">Account created on</Typography>
            <Typography variant="body2" className={classes.accountCreationText}>
              {stringToSemanticDisplay(value)}
            </Typography>
          </SuccessStateInfo>
        );
      }
      return (
        <Box className={classes.iconContainer}>
          <Button
            disabled={generateLoading}
            className={classes.viewDetailsButton}
            variant="text"
            onClick={() => generateMutate(tableMeta)}
            size="small"
          >
            Generate Account
          </Button>
        </Box>
      );
    },
    sort: remoteTotalRowsSelected === 0,
    filter: false,
  },
});

export const emailSentColumn = (
  classes: any,
  remoteTotalRowsSelected: number
): MUIDataTableColumn => ({
  name: 'emailDateTime',
  label: 'Email Sent',
  options: {
    customBodyRender: (value: any, tableMeta: MUIDataTableMeta, updateValue: (value: any) => void)  => {
      if (value) {
        return (
          <SuccessStateInfo>
            <Typography variant="body2">Email sent on</Typography>
            <Typography variant="body2" className={classes.accountCreationText}>
              {stringToLongDateAndShortTimeWithSecond(value, false)}
            </Typography>
          </SuccessStateInfo>
        );
      }
      return (
        <Typography variant="body2" className={classes.emailSentText}>
          –
        </Typography>
      );
    },
    sort: remoteTotalRowsSelected === 0,
    filter: false,
  },
});

export const actionColumn = (
  classes: any,
  editDetail: (editDetail: any[]) => void,
  hasEditAccess: boolean
): MUIDataTableColumn => ({
  name: 'action',
  label: 'Action',
  options: {
    display: hasEditAccess,
    customBodyRender: (value: any, tableMeta: MUIDataTableMeta, updateValue: (value: any) => void)  => (
      <Box className={classes.iconContainer}>
        <Icon size="M" className={`${classes.icon} ${classes.iconDefault}`} name={IconName.edit} />
        <Button
          className={classes.viewDetailsButton}
          variant="text"
          color="primary"
          onClick={() => editDetail(tableMeta.rowData)}
          size="small"
        >
          Edit
        </Button>
      </Box>
    ),
    sort: false,
    filter: false,
  },
});

export const sendEmailColumn = (
  classes: any,
  emailLoading: boolean,
  emailMutate: (tableMeta: MUIDataTableMeta) => void
): MUIDataTableColumn => ({
  name: '',
  options: {
    customBodyRender: (value: any, tableMeta: MUIDataTableMeta, updateValue: (value: any) => void)  => {
      const disabled = !tableMeta.rowData[5] || emailLoading;

      return (
        <Box className={classes.iconContainer}>
          <Icon
            size="M"
            className={`${classes.icon} ${classes.iconEmail} ${
              disabled ? classes.iconDisable : classes.iconDefault
            }`}
            name={IconName.email}
          />
          <Button
            disabled={disabled}
            className={classes.viewDetailsButton}
            variant="text"
            color="primary"
            onClick={() => emailMutate(tableMeta)}
            size="small"
          >
            Send Email
          </Button>
        </Box>
      );
    },
    sort: false,
    filter: false,
  },
});

export const indexNumberColumn: MUIDataTableColumn = {
  name: 'indexNumber',
  options: {
    display: false,
    filter: false,
  },
};
